/** @jsx h */
import { h } from 'preact'

const FooterCTA = ({ children, href }) =>
  <a class='FooterCTA' href={href} target='_blank' rel='external nofollow noreferrer'>
    {children}
  </a>

export default FooterCTA
